<template>
  <div>
    <div v-if="oneClickFromContext" class="mt-2">
      <p>{{ actionTakerName }}</p>
      <not-me-link :user-name="actionTakerName" />
    </div>
    <div v-if="oneClickFromCrm" class="mb-2">
      <p>
        <strong>
          {{ i18n.t('public.one_click.welcome_back', {name: actionTakerName}) }}
        </strong>
      </p>
      <not-me-link :user-name="actionTakerName" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NotMeLink from './not-me-link'

export default {
  components: { NotMeLink},

  computed: {
    ...mapState(['actionTakerName', 'oneClickFromContext', 'oneClickFromCrm'])
  }
}
</script>
